import Nullstack from 'nullstack';
export default function IconMoodSadSquint({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mood-sad-squint",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 11.5l1.5 -1.5l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 11.5l-1.5 -1.5l1.5 -1.5"
  }), " ");
}